/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { surveyApi } from "../../../../api/surveyApi";
import Table from "../../../../component/common/Table";
import Loader from "../../../../component/common/Loader";
import { SURVEY_STATUS } from "../../../../utils/constants";
import Topbar from "../../../../container/PulseSurvey/Topbar";
import { useNavigate, useSearchParams } from "react-router-dom";
import SearchInput from "../../../../component/common/Input/SearchInput";
import Pagination from "../../../../component/common/Pagination/Pagination";
import {
  errorToast,
  getPathForSurvey,
  isSubAdmin,
} from "../../../../utils/helper";
import { TableCard } from '../../../../component/common/designSystem';

const columns = [
  {
    title: "Name",
    key: "name",
    type: "text",
    align: "left",
    extend: true,
    style: {
      opacity: "opacity-100",
    },
  },
  {
    title: "Approval Status",
    key: "approvalStatus",
    type: "text",
    align: "left",
    extend: true,
    style: {
      opacity: "opacity-70",
    },
  },
  {
    title: "Created By",
    key: "createdBy",
    type: "text",
    longText: false,
    align: "left",
    extend: true,
    style: {
      opacity: "opacity-100",
    },
  },
  {
    title: "Approved By",
    key: "approvedBy",
    type: "text",
    extend: true,
    align: "left",
    style: {
      opacity: "opacity-100",
    },
  },
];

const ViewAllRewards = () => {
  const navigate = useNavigate();
  const [survey, setSurvey] = useState([]);
  const [loader, setLoader] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rewardType, setRewardType] = useState(6);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [surveyType, setSurveyType] = useState(SURVEY_STATUS.DRAFT);
  const { userType } = JSON.parse(localStorage.getItem("userData"));
  const [selectedPerPage, setSelectedPerPage] = useState({
    name: "10",
    value: 10,
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const searchQuery = Object.fromEntries(searchParams);
  const type = searchQuery.type;

  const handleFilterOption = (option) => {
    setRewardType(option);
    setIsFilterOpen(false);
  };

  const toggleFilter = () => {
    setIsFilterOpen((prev) => !prev);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handlePagination = (
    pageNumber,
    pageSize,
    searchKey,
    date,
    query,
    sortBy,
    sortOrder
  ) => {
    setLoader(true);

    if (userType === 0 || userType === 1) {
      surveyApi
        .getSurveys(
          pageNumber,
          pageSize,
          undefined,
          type,
          surveyType,
          searchKey,
          date
        )
        .then((response) => {
          if (response?.data?.meta?.code === 200) {
            setCurrentPage(pageNumber);
            setSurvey(response?.data?.data || []);
            setTotalCount(response?.data?.meta?.total || 0);
            setLoader(false);
          } else if (response?.code === 401) {
            setLoader(false);
            errorToast(response?.message);
          } else if (response?.data?.meta?.code === 0) {
            setCurrentPage(1);
            setSurvey([]);
            setTotalCount(0);
            setLoader(false);
            errorToast(response?.data?.meta?.message);
          } else {
            setLoader(false);
          }
        });
    }
    if (userType === 3 || userType === 4) {
      surveyApi
        .getSurveyAll(
          pageNumber,
          pageSize,
          undefined,
          type,
          surveyType,
          searchKey
        )
        .then((response) => {
          if (response?.data?.meta?.code === 200) {
            setCurrentPage(pageNumber);
            setSurvey(response?.data?.data || []);
            setTotalCount(response?.data?.meta?.total || 0);
            setLoader(false);
          } else if (response?.code === 401) {
            setLoader(false);
            errorToast(response?.message);
          } else if (response?.data?.meta?.code === 0) {
            setCurrentPage(1);
            setSurvey([]);
            setTotalCount(0);
            setLoader(false);
            errorToast(response?.data?.meta?.message);
          } else {
            setLoader(false);
          }
        });
    }
  };

  const tableData = survey?.map((item) => {
    return {
      name: "item?.title",
      approvalStatus: "Approved",
      createdBy: "item?.createdBy",
      approvedBy: "item?.approvalBy",
    };
  });

  return (
    <div className="mx-auto max-w-[1640px]">
      {loader && <Loader />}
      <Topbar title={"All Rewards"} />
      <div className="flex flex-wrap sm:justify-between gap-4 justify-center lg:mt-8 sm:mb-4">
        <div className="flex flex-col sm:flex-row w-full sm:w-auto">
          <div className="w-full sm:w-auto">
            <SearchInput
              id="searchKey"
              name="searchKey"
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              placeholder="Search Rewards"
              className="w-full max-w-md border rounded-md p-2"
            />
          </div>
        </div>
        <div className="flex flex-wrap sm:justify-end w-full sm:w-auto">
          <div className="relative inline-block text-left mb-4 sm:mb-0 mr-2">
            <button
              type="button"
              onClick={toggleFilter}
              className="inline-flex justify-between items-center w-full px-3 py-[7px] sm:text-sm text-[12px] font-medium text-gray-700 border dark:border-text-shoorah-darkBg border-[#0B1D2E] sm:rounded-[100px] rounded-[80px] dark:text-shoorah-darkBg dark:border-shoorah-darkBg"
            >
              {rewardType === 0
                ? "Draft"
                : rewardType === 1
                ? "Inactive"
                : rewardType === 2
                ? "Active"
                : rewardType === 3
                ? "Send for Approval"
                : rewardType === 4
                ? "Rejected"
                : rewardType === 5
                ? "Deleted"
                : rewardType === 6
                ? "Published"
                : "Filter"}
              <svg
                className={`transform transition-transform ml-0 sm:ml-3 dark:invert ${
                  isFilterOpen ? "rotate-180" : "rotate-0"
                }`}
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                  stroke="#0B1D2E"
                  strokeMiterlimit="10"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            {isFilterOpen && (
              <div className="absolute left-[-12px] z-10 mt-1 w-[160px] bg-white divide-y divide-gray-100 rounded-md ring-1 ring-[#E7EAE8] ring-opacity-1 dark:bg-shoorah-darkBgColor dark:border-shoorah-darkBorder dark:ring-opacity-0">
                <ul className="py-1 text-sm text-shoorah-lightBlack dark:text-shoorah-darkBg">
                  <li>
                    <button
                      onClick={() => handleFilterOption(0)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Draft
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(1)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Inactive
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(2)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Active
                    </button>
                  </li>
                  {isSubAdmin() && (
                    <li>
                      <button
                        onClick={() => handleFilterOption(3)}
                        className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                      >
                        Send For Approval
                      </button>
                    </li>
                  )}

                  <li>
                    <button
                      onClick={() => handleFilterOption(4)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Rejected
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(5)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Deleted
                    </button>
                  </li>
                  <li>
                    <button
                      onClick={() => handleFilterOption(6)}
                      className="block px-4 py-2 w-full text-left hover:bg-gray-100 dark:hover:text-shoorah-darkBgColor capitalize"
                    >
                      Published
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
          <div
            className="flex flex-row relative justify-center items-center w-full sm:w-[170px] sm:p-0 px-4 h-[40px] bg-[#1F1F1F] text-[16px] rounded-[100px] text-[#F4F4F4] cursor-pointer"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div className="relative inline-block text-left">
              <button className="flex flex-row items-center" type="button">
                Create New
                <svg
                  className={`transform transtion-transform ml-0 sm:ml-2 ${
                    isOpen ? "rotate-180" : "rotate-0"
                  }`}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                    stroke="#0B1D2E"
                    strokeMiterlimit="10"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="stroke-shoorah-darkBg"
                  />
                </svg>
              </button>

              {isOpen && (
                <div className="absolute -left-20 top-8 z-10 mt-1 w-[220px] bg-white divide-y divide-shoorah-gray1 border-[1.5px] dark:border-shoorah-darkBorder dark:bg-shoorah-darkBgTabColor border-shoorah-gray1 rounded-lg">
                  <ul className="py-[14px] text-[16px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg w-full">
                    <li>
                      <button
                        onClick={() =>
                          navigate(
                            getPathForSurvey(
                              "/team-challanges/add-edit-challenges"
                            )
                          )
                        }
                        className="block px-5 py-2 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                      >
                        New Challenge
                      </button>
                    </li>
                    <li className="w-[calc(100%-40px)] h-[1px] bg-shoorah-gray1 mx-auto my-1"></li>
                    <li>
                      <button
                        onClick={() =>
                          navigate(
                            getPathForSurvey(
                              "/team-challanges/add-edit-rewards?tab=1"
                            )
                          )
                        }
                        className="block px-5 py-2 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                      >
                        New Shoorah Reward
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="space-y-6 pb-16 mt-4">
        <TableCard
          pagination={{
            currentPage: currentPage,
            totalCount: totalCount,
            pageSize: selectedPerPage?.value,
            onPageChange: (page) =>
            handlePagination(page, selectedPerPage?.value, searchTerm)
          }}
        >
          <Table columns={columns} data={tableData} name={"surveys"} />
        </TableCard>
        
      </div>
    </div>
  );
};

export default ViewAllRewards;
